import { Component, ViewChild } from '@angular/core';
import { OnInit } from "@angular/core";
import { SessionStorageService } from "./../shared/services/session-storage.service";
import { Router } from '@angular/router';
import { SnackbarService } from "./../shared/services/snackbar.service";
import { SharedService } from '../shared/services/shared.service';
import { ValidationService } from "./../shared/services/validation.service";

import { config } from './../../../config/index';
import { isValidNumber } from 'libphonenumber-js';
import { contactViewPipe } from '../pipes/phone-view.pipe';
import { phoneFormatPipe } from '../pipes/phone-formatter.pipe';

@Component({
    template: require('./virtual-consultation-progress-checkup.component.html'),
    styles: [require('./virtual-consultation-progress-checkup.component.less')],
    preserveWhitespaces: true,
    providers: [SnackbarService, contactViewPipe, phoneFormatPipe]
})


export class VCProgressCheckupComponent implements OnInit {

    constructor(
        private phoneFormatPipe: phoneFormatPipe,
        private contactViewPipe: contactViewPipe,
        private _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService,
        private _router: Router,
        private _sharedService:SharedService,
        private _validationService: ValidationService,
    ) {}

    @ViewChild("datePicker", { static: false }) dateFieldRef: any;

    isMobile: boolean = false;
    locations: any = [];
    doctors: any = [];
    _patientfile: any = {};
    dataRequired: boolean = false;
    dob: any;
    headingClass: string = '';
    contentClass: string = '';
    initialHeight: any;
    initialWidth: any;
    confirmEmailError : boolean = false;
    contactError: boolean = false;
    contactMethods: any = ['Email', 'Text', 'Phone'];
    nextClickedClass = '';
    prevClickedClass = '';
    tomorrow = new Date();
    dobError: boolean = false;
    genders: any = ['Male', 'Female', 'Non-Binary'];
    zipError: boolean;
    postalFormat: any = /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
    zipFormat: any = /\b\d{5}\b/;
    phoneCategory: any = ['home', 'mobile'];
    phoneNumRegex: any =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    stateProvinceLabel = 'STATE';
    GenderClass: string = 'selector';
    emailRegex: any = config.emailRegex;
    emailRegexPattern: any = config.emailRegexPattern;
    hasEmailError: boolean;

    nextPage() {
        if (this.nextClickedClass !== 'nextClickClass') {
            this.nextClickedClass = 'nextClickClass';
            this.validation(this._patientfile);
            setTimeout(() => {
                this.nextClickedClass = '';
                if (this.dataRequired) {
                    this._sharedService.scrollToError('.text-error');
                } else {
                    if(this._patientfile.pageIndex < 4){
                        if(this.doctors.length === 1 && this._patientfile.pageIndex === 1 ) {
                            this.setDoctorList(this._patientfile.location_id)
                            this._patientfile.pageIndex = this._patientfile.pageIndex + 1;
                        }
                        this._patientfile.pageIndex = this._patientfile.pageIndex + 1;
                        this._sessionStorageService.saveItem('patientFile', this._patientfile);
                        this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                        this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
                    }else {
                        this._patientfile.photoType = 1;
                        this._sessionStorageService.saveItem('patientFile', this._patientfile);
                        this._router.navigate(['vc-photo-upload'], { replaceUrl: true });
                    }
                }
            }, 300);
        }
    }

    prevPage() {
        this.prevClickedClass = 'prevClickClass';
        setTimeout(() => {
            this.prevClickedClass = '';
            if(this._patientfile.pageIndex >1){
                if(this._patientfile.locations.length === 1 && this._patientfile.pageIndex ===  3 ){
                    if(this._patientfile.locations[0].doctor_list.length === 1 && this._patientfile.pageIndex ===  3){
                        this._patientfile.pageIndex = 1;
                       if(this._patientfile.locations.length === 1){
                        this._router.navigate(['vc-start/' + this._patientfile.token]);
                        }
                    }
                    else {
                        this._patientfile.pageIndex = this._patientfile.pageIndex - 1;
                    }
                } else {
                    this._patientfile.pageIndex = this._patientfile.pageIndex - 1;
                }
                if(this.doctors.length === 1 && this._patientfile.pageIndex ===  2){
                    this._patientfile.pageIndex = this._patientfile.pageIndex - 1;
                }
                if(this._patientfile.locations.length === 1 && this._patientfile.pageIndex ===  1){
                    this._router.navigate(['vc-start/' + this._patientfile.token]);
                }
                this._sessionStorageService.saveItem('patientFile', this._patientfile);
                this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
            } else {
                this._sessionStorageService.saveItem('patientFile', this._patientfile);
                this._router.navigate(['vc-start/' + this._patientfile.token], { replaceUrl: true });
            }
        }, 300);
    }

    checkData() {
        this._sessionStorageService.readItem('patientFile').then((data: any) => {
            if(data) {
                this._patientfile = data;
                this._patientfile.countryCode = data.country.code;
                if (this._patientfile.country.name === 'USA') {
                    this.stateProvinceLabel = 'STATE';
                } else if (this._patientfile.country.name === 'Canada') {
                    this.stateProvinceLabel = 'PROVINCE';
                } else {
                    this.stateProvinceLabel = 'STATE_PROVINCE';
                }
                if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
                    this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
                }
                this._patientfile.country_id = data.country.id;
                if (!this._patientfile.state_id) {
                    this._patientfile.state_id = data.state.id;
                }
                this.locations = data.locations;
                if(!this._patientfile.phone_number_type){
                    this._patientfile.phone_number_type = 'mobile';
                }
                if(data.locations.length === 1 && (!this._patientfile.pageIndex || this._patientfile.pageIndex < 3)){
                    this._patientfile.pageIndex = 2;
                    this._patientfile.location_id = this._patientfile.locations[0].id;
                    this._patientfile.location_contact_number = this._patientfile.locations[0].contact_number;
                   if(data.locations[0].doctor_list.length === 1){
                       this._patientfile.pageIndex = 3;
                       this._patientfile.doctor_id = this._patientfile.locations[0].doctor_list[0].id;
                    }
                }
                if (data.location_id) {
                    let selectedLocation = this.locations.find((value: any) => value.id === data.location_id);
                    this.doctors = selectedLocation.doctor_list;
                }
                this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
                if (!this._patientfile.pageIndex) {
                    this._patientfile.pageIndex = 1;
                    this.headingClass = 'heading-height-page-1';
                    this.contentClass = 'content-height-page-1';
                } else {
                    this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                }
            } else {
                this._patientfile.pageIndex = 1;
                this.headingClass = 'heading-height-page-1';
                this.contentClass = 'content-height-page-1';
            }
	    });
    }

    setDoctorList(id: any) {
        this._patientfile.doctor_id = null;
        let selectedLocation = this.locations.find((value: any) => value.id === id);
        this.doctors = selectedLocation.doctor_list;
        if(this.doctors.length === 1) {
            this._patientfile.doctor_id = this.doctors[0].id
        }
        this._patientfile.location_contact_number = selectedLocation.contact_number;
    }

    //Gender select styling purpose
    genderSelected() {
        if (this._patientfile.gender !== undefined) {
            this.GenderClass = 'selector';
        }
    }

    validation(value: any) {
        const EMAIL_REGEXP = new RegExp(this.emailRegex);
        if (value.pageIndex === 1) {
            if (this._patientfile.location_id) {
                this.dataRequired = false;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_LOCATION');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 2) {
            if (this._patientfile.doctor_id) {
                this.dataRequired = false;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_DOCTOR');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 3) {
            this.hasEmailError = false;
            this.dobError = !this._validationService.validateDate(value.dob)
            this.validateContactNumber();
            if (this._patientfile.gender === undefined) {
                this.GenderClass = 'selector radio-invalid';
            }
            if (value.first_name && value.last_name
                && value.first_name !== '' && value.last_name !== ''
                && value.email && value.email !==''
                && !this.contactError && value.best_contact_method
                && this._patientfile.phone_number_type
                && value.confirm_email && value.confirm_email !== ''
                && !this.dobError && !this.confirmEmailError
                && this._patientfile.gender
                && value.mailing_street_address_1 && value.mailing_street_address_1 !== ''
                && value.state_id
                && value.zip_code_postal_code && value.zip_code_postal_code !== '' && !this.zipError
                && value.city && value.city !== ''
                ) {
                    if (!EMAIL_REGEXP.test(value.email)) {
                        this.hasEmailError = true;
                        this._mdlSnackbarService.showSnackbar('PROVIDE_VALID_EMAIL');
                        this.dataRequired = true;
                    } else {
                        this.dataRequired = false;
                    }
            } else {
                this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 4) {
            if (value.has_aligner) {
                this.dataRequired = false;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_AN_OPTION');
                this.dataRequired = true;
            }
        }
    }

    checkEmail() {
        if (this._patientfile.confirm_email !== this._patientfile.email) {
            this.confirmEmailError = true;
        } else {
            this.confirmEmailError = false;
        }
    }

    ngOnInit() {
        this.isMobile = this._sharedService.isMobileOrTabletDevice();
        this.checkData();
        // setting viewport to initial style on soft keyboard(mobile)
        this.initialHeight = document.documentElement.clientHeight;
        this.initialWidth = document.documentElement.clientWidth;
        let that = this;
        window.addEventListener('resize', function(event: any) {
            document.documentElement.style.setProperty('overflow', 'auto')
            const metaViewport = document.querySelector('meta[name=viewport]')
            if (event.currentTarget.innerWidth === that.initialWidth) {
                metaViewport.setAttribute('content', 'height=' + that.initialHeight + 'px, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
            } else {
                metaViewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
            }
        });
        this.tomorrow.setDate(this.tomorrow.getDate());
    }

    openPicker() {
        if(document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
            setTimeout(this.dateFieldRef.instance.show, 150);
        }   
    }

    phoneNumberInput() {
        if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
            this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
            this._patientfile.phone_number = this.contactViewPipe.transform(this._patientfile.phone_number);
        } else {
            this._patientfile.phone_number = this.contactViewPipe.transformNational(this._patientfile.phone_number, this._patientfile.countryCode);
        }
        this.validateContactNumber();
    }

    validateContactNumber() {
        this.contactError = false;
        if (this._patientfile.phone_number && this._patientfile.countryCode) {
            if (this._patientfile.countryCode === 'US' || this._patientfile.countryCode === 'CA') {
                this.contactError = !this.phoneNumRegex.test(this._patientfile.phone_number);
            } else {
                this.contactError = !isValidNumber(this._patientfile.phone_number, this._patientfile.countryCode);
            }
        } else {
            this.contactError = true;
        }
    }

    onCountryChange(event: any) {
        let selectedCountry = this._patientfile.country_list.filter((item: any) => item.id === event);
        this._patientfile.country = selectedCountry[0];
        this._patientfile.countryCode = this._patientfile.country.code;

        if (this._patientfile.country.name === 'USA') {
            this.stateProvinceLabel = 'STATE';
        } else if (this._patientfile.country.name === 'Canada') {
            this.stateProvinceLabel = 'PROVINCE';
        } else {
            this.stateProvinceLabel = 'STATE_PROVINCE';
        }

        this._patientfile.country_id = this._patientfile.country.id;
        this._patientfile.state_id = '';
        this._patientfile.phone_number = '';
        this._patientfile.zip_code_postal_code = '';

        if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
            this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
        }
    }

    checkDobError() {
        this.dobError = !this._validationService.validateDate(this._patientfile.dob);
    }

    zipFormatter(isZip? : boolean) {
        if (!isZip) {
            let cleaned = ('' + this._patientfile.zip_code_postal_code).replace(/\s/g, ''),
                formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const last = cleaned.substring(3, 6);

            if (cleaned.length > 3) {
                formattedVal = `${zip} ${last}`;
            } else if (cleaned.length > 0) {
                formattedVal = `${zip}`;
            }
            this.zipError = !this.postalFormat.test(formattedVal);

            setTimeout(() => {
                this._patientfile.zip_code_postal_code = formattedVal;
            });
        } else {
            let cleaned = ('' + this._patientfile.zip_code_postal_code).replace(/\D/g, '').slice(0, 10);
            this.zipError = !this.zipFormat.test(cleaned);

            setTimeout(() => {
                this._patientfile.zip_code_postal_code = cleaned;
            });
        }
    }
}